<template>
    <tr :id="`detailsRow_${entry.id}`" class="additionalDetailsRow" style="display:none;">
        <td colspan="14" style="background:#f1f1f1; border-bottom:solid 1px #ccc; color:#666; padding:0.5rem;">
            <ul style="list-style-type: none;">
                <li>
                    <strong>Submitted By:</strong> {{ entry.additionalDetails.submittedByUser }}
                </li>
                <li v-if="entry.additionalDetails.requestedByUser">
                    <strong>Requested By:</strong> {{ entry.additionalDetails.requestedByUser }}
                </li>
                <li v-if="entry.additionalDetails.skus">
                    <strong>SKUs:</strong> {{ entry.additionalDetails.skus }}
                </li>
                <li v-if="entry.add_details">
                    <strong>Additional Details:</strong> {{ entry.add_details }}
                </li>
            </ul>
        </td>
    </tr>
</template>

<script>
export default {
    props: ['entry']
}
</script>